import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons"

const CarouselPrevButton = ({ onClick }) => {
  return(
    <button onClick={onClick} className="slider-arrow prev" aria-label="Previous">
      <FontAwesomeIcon icon={faAngleLeft} />
    </button>
  ) 
}

export default CarouselPrevButton